import React, { useCallback, useMemo, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, rowPhoto, getActions, addActionOnRow } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { WorkerForm } from '../worker-form/WorkerForm'
import { useSelector } from 'react-redux'

export const WorkerView = () => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/worker'
  })

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'trabajadores' })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_worker

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <WorkerForm rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/worker/delete',
            data: {
              p_id_worker: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        {
          name: 'photo_worker', text: 'Foto', render: row => rowPhoto(row.photo_worker, row.name_worker), align: 'center'
        },
        { name: 'name_worker', text: 'Nombres', align: 'center' },
        { name: 'last_name_worker', text: 'Apellidos', align: 'center' },
        { name: 'name_profile', text: 'Perfil', align: 'center' },
        { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
        { name: 'username_user', text: 'Nombre de Usuario', align: 'center' },
        { name: 'enabled_worker', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_worker }) },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          {rowItem({
            type: 'create'
          })}
          {dtRows}
        </Card.Body>
      </Card>
    </div>
  </div>
}